import React, { memo, useCallback, useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux'
import { ActivityIndicator, View, FlatList, Text } from "react-native-web";
import AppointmentHandler from '../../components/AppointmentHandler';
import { fetchmAppointmentsFromApi } from "../../../shared/actions/MissedAppointmentActions";
import { GetDayName, GetAppointmentDate, GetMonthName, ReturnTypeIcon, GetYear, FormateUTCTime } from '../../../shared/core/datehelper';
import getUserInfo from '../../../shared/core/GetTokenized';
import { appServices } from '../../../shared/redux/actions/appServices';

const MissedAppointmentView = props => {

    // const { MissedAppointments, isGetting } = props.MissedAppointments;
    const [pageSize, setPageSize] = useState(100);           //state for the page number
    const [pageNumber, setPageNumber] = useState(1);           //state for the page number
    const  {AppointmentsData , isAppointmentsLoading} =useSelector((state)=> state.Appointments)
    const dispatch= useDispatch();
    const { Profile, isFetching } = useSelector((state)=> state.PatientProfile)
    const information =  getUserInfo(); // Get the user info (will resolve the promise)
      const PatienInformation = JSON.parse(information);
    const fAppointmentObj={
        PatientID: Profile[0].resource.id,
        PageSize : pageSize,
        PageNumber: pageNumber ,
        AppointmentType: 2
    }
    useEffect(() => {
        //alert('Called Future')
        // props.getMissedAppoint(pageSize, pageNumber);
        if(props.activeKey==="3"){
        dispatch(appServices.Appointments(fAppointmentObj))}
    }, [props.activeKey])
    return (
        <div>
            {
                isAppointmentsLoading && <View style={{ textAlign: 'center', marginBottom: 5 }}><ActivityIndicator size="small" color="#00A1DE" /></View>
            }
            {
                AppointmentsData && AppointmentsData.length ? (
                    <FlatList
                        style={{
                            flexDirection: 'column', paddingLeft: 10,
                            paddingRight: 10,
                            paddingBottom: 10
                        }}
                        //contentContainerStyle={{ flexDirection: "row", flexWrap: "wrap", justifyContent: 'space-evenly' }}
                        data={AppointmentsData}
                        renderItem={({ item }) => (
                            <AppointmentHandler
                                styleName={'card-header text-white bg-danger'}
                                appointmentDate={GetAppointmentDate(item.resource.period.start) + ' ' + GetMonthName(item.resource.period.start) + ' ' + GetYear(item.resource.period.start)}
                                praticeAddress={item.resource.extension[3].hasOwnProperty('valueString') ? item.resource.extension[3].valueString : '(N/A)'}
                                firstitem={item.resource.extension[2].valueString}
                                secondItem={GetDayName(item.resource.period.start) + ', ' + FormateUTCTime(item.resource.period.start)}
                                patientDetails={item.resource.extension[1].valueString} //+ ', ' + item.resource.extension[0].valueString}}
                                location={item.resource.extension[10].hasOwnProperty('valueString') ? item.resource.extension[10].valueString : '(N/A)'}
                                reasonForCancel={null}

                            />
                        )}
                        horizontal={false}
                        keyExtractor={item => item.resource.id}
                        initialNumToRender={30}

                    />
                ) : !isAppointmentsLoading && <View style={{ flex: 1, flexDirection: "column", justifyContent: 'center', alignItems: 'center' }}>
                    <Text style={{ marginTop: 10, }}>No Records Found</Text>
                </View>
            }

        </div>

    );
}



// function mapStateToProps(state) {
//     return {
//         MissedAppointments: state.MissedAppointments
//     }
// }

// function mapDispatchToProps(dispatch) {
//     return {
//         getMissedAppoint: (pageSize, pageNumber) => dispatch(fetchmAppointmentsFromApi(pageSize, pageNumber)),

//     }
// }
// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(MissedAppointmentView)

export default MissedAppointmentView
